class BackendAPI {
  constructor() {
    this.accessToken = window.customer?.accessToken || "";
    this.apiUrl = window.BACKEND_BASE_URL;
    this.refreshToken = window.customer?.refreshToken || "";
    this.headers = {
      Accept: "application/json",
      "Content-Type": "application/json",
    };
    this.getRewards();
    this.validateToken();
  }

  showError(message) {
    console.error(message);
    // Add error display logic if needed
  }

  isTokenExpired(token) {
    if (!token) return true;

    try {
      const bodyB64 = token.split(".")[1];
      const decBody = JSON.parse(atob(bodyB64));
      const { exp } = decBody;
      const now = Math.floor(Date.now() / 1000);
      return exp < now;
    } catch (error) {
      console.error("Error checking token expiration:", error);
      return true;
    }
  }

  async getAccessToken() {
    const response = await fetch(`${this.apiUrl}/gap/auth/public`, {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify({
        customer_id: window.customer?.id,
        email: window.customer?.email,
        signature: window.customer?.signature,
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    const data = await response.json();
    window.customer.accessToken = data.token;
    window.customer.refreshToken = data.refresh_token;
  }

  async refreshAccessToken() {
    const refreshResponse = await fetch(
      `${this.apiUrl}/gap/auth/public/refresh`,
      {
        method: "POST",
        headers: this.headers,
        body: JSON.stringify({
          refresh_token: this.refreshToken,
        }),
      }
    );
    const refreshData = await refreshResponse.json();
    window.customer.accessToken = refreshData.token;
    window.customer.refreshToken = refreshData.refresh_token;
  }

  async validateToken() {
    if (!window.customer) return;

    if (
      (window.customer.refreshToken &&
        this.isTokenExpired(window.customer.refreshToken)) ||
      !window.customer.accessToken
    ) {
      await this.getAccessToken();
    }

    if (this.isTokenExpired(window.customer.accessToken)) {
      await this.refreshAccessToken();
    }
  }


  async getRewards() {
    console.log('getRewards');
    try {
        const response = await fetch(`${this.apiUrl}/gap/auth/public`, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify({
                customer_id: window.customer?.id,
                email: window.customer?.email,
                signature: window.customer?.signature
            })
        });
        if (!response.ok) {
            throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        window.customer.accessToken = data.token;
        window.customer.refreshToken = data.refresh_token;
        if(this.isTokenExpired(data.token)){  
            const refreshResponse = await fetch(`${this.apiUrl}/gap/auth/public/refresh`, {
                method: 'POST',
                headers: this.headers,
                body: JSON.stringify({
                    refresh_token: this.refreshToken
                })
            });
            const refreshData = await refreshResponse.json();
            window.customer.accessToken = refreshData.token;
            window.customer.refreshToken = refreshData.refresh_token;
        } else {
            this.fetchRewards(data);
        }
        return data;
        
    } catch (error) {
        console.error('Error fetching rewards:', error);
        this.showError(`Failed to load rewards: ${error.message}`);
        this.displayRewards(null);
    }
  }
  async fetchRewards() {
      const response = await fetch(`${this.apiUrl}/gap/rewards`, {
          headers: {
              ...this.headers,
              'Authorization': `Bearer ${window.customer.accessToken}`
          }
      });
      const rewards = await response.json();
      if(rewards != null){
      this.displayRewards(rewards);
      } else {
          document.querySelector('.rewards-container')?.classList.add('hidden');
      }
  }
  displayRewards(rewards) {
      const loadingEl = document.getElementById('loading');
      const reward_container =  document.querySelector('.rewards-container');
      const errorEl = document.getElementById('error-container');
      const rewardsGridEl = document.getElementById('rewards-grid');
    
      loadingEl.style.display = 'none';
      errorEl.style.display = 'none';
      rewardsGridEl.style.display = 'flex';
      
      if (!rewards || rewards.length === 0 || rewards == null) {
          rewardsGridEl.style.display = 'none';
          return;
      }
      reward_container?.classList.remove('hidden');
      const rewardTitle = reward_container?.dataset?.rewardTitle || 'Host Reward Discount';
      rewardsGridEl.innerHTML = rewards.map(reward => {
          // Format expiration date
          const expirationDate = new Date(reward.expires_at);
          const formattedDate = expirationDate.toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
          });
          
          return `
              <div class="reward-card">
                  <h6 class="coupon-title body-size-4 strong">${rewardTitle}</h6>
                  <div class="coupon-code-container">
                      <div class="coupon-code">${reward.code}</div>
                  </div>
                  <div class="coupon-expiry mt-r5">Expires: ${formattedDate}</div>
              </div>
          `;
      }).join('');
      const couponCodeContainers = document.querySelectorAll('.coupon-code-container');
      couponCodeContainers.forEach(container => {
          container.addEventListener('click', () => {
              container.classList.add('copied');
              navigator.clipboard.writeText(container.querySelector('.coupon-code').textContent);
              setTimeout(() => {
                  container.classList.remove('copied');
              }, 2000);
          });
      });
  }

  async getPreferredDistributor() {
    console.log("getPreferredDistributor");
    try {
      await this.validateToken();
      const response = await fetch(`${this.apiUrl}/distributors/preferred`, {
        headers: {
          ...this.headers,
          Authorization: `Bearer ${window.customer.accessToken}`,
        },
      });
      const distributor = await response.json();
      return distributor;
    } catch (error) {
      console.error("Error fetching distributor:", error);
      this.showError(`Failed to get distributor: ${error.message}`);
    }
  }

  async getDistrbutorBySiteName(site_name) {
    console.log("getDistrbutorBySiteName", site_name);
    try {
      const response = await fetch(
        `${this.apiUrl}/distributors/?site_name=${site_name}`,
        {
          headers: {
            ...this.headers,
          },
        }
      );
      const distributor = await response.json();
      return distributor;
    } catch (error) {
      console.error("Error fetching distributor:", error);
      this.showError(`Failed to get distributor: ${error.message}`);
    }
  }

  async setDistributor(site_name) {
    try {
      console.log("setDistributor");

      await this.validateToken();
      const response = await fetch(
        `${this.apiUrl}/gap/affiliate?site_name=${site_name}`,
        {
          method: "POST",
          headers: {
            ...this.headers,
            Authorization: `Bearer ${window.customer.accessToken}`,
          },
        }
      );
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error setting distributor:", error);
      this.showError(`Failed to set distributor: ${error.message}`);
    }
  }

  async removeDistributor() {
    try {
      console.log("removeDistributor");

      await this.validateToken();
      const response = await fetch(`${this.apiUrl}/gap/affiliate`, {
        method: "DELETE",
        headers: {
          ...this.headers,
          Authorization: `Bearer ${window.customer.accessToken}`,
        },
      });
      const responseData = await response.json();
      return responseData;
    } catch (error) {
      console.error("Error removing distributor:", error);
      this.showError(`Failed to remove distributor: ${error.message}`);
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  window.backend = new BackendAPI();
});
